<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">点位管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>母子点位管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="left">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText"
          style="margin-bottom:10px;"
        >
        </el-input>
        <el-tree
          ref="tree"
          highlight-current
          :default-expand-all="true"
          node-key="id"
          :data="treeData"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
        >
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span
              :style="{
                color: node.isCurrent
                  ? '#3B70FF'
                  : node.levelCode == 5
                  ? '#85859d'
                  : '#32325A',
                fontWeight: node.isCurrent ? 700 : 400
              }"
            >
              {{ node.label }}
            </span>
          </span>
        </el-tree>
      </div>
      <div class="right">
        <div class="right-top1">
          <div class="street">
            <span> {{ pointInfo.pointName }}</span>
            <el-button
              v-if="pointInfo.levelCode == 3"
              @click="dialogVisible = true"
              class="other"
              >更换网格图层</el-button
            >
          </div>
          <div class="content">{{ pointInfo.briefInfo }}</div>
          <div class="info-box">
            <div class="info-box-item">
              <img src="@/assets/image/ld.png" alt="" />
              <span style=" color: #92979C;">楼栋数</span>
              <span>{{ pointInfo.buildingInfo }}</span>
            </div>
            <div class="info-box-item">
              <img src="@/assets/image/mj.png" alt="" />
              <span style=" color: #92979C;">面积</span>
              <span>{{ pointInfo.areaInfo }}</span>
            </div>
          </div>
          <div class="info-box">
            <div class="info-box-item">
              <img src="@/assets/image/dh.png" alt="" />
              <span style=" color: #92979C;">咨询、监督电话</span>
              <span>{{ pointInfo.phoneList }}</span>
            </div>
          </div>
        </div>
        <div class="right-bottom">
          <div class="tabs">
            <div class="tabs-box">
              <div
                class="tabs-item"
                :class="{ active: curTab == item.value }"
                v-for="(item, index) in tabsOptions"
                :key="index"
                @click="tabsChange(item)"
              >
                {{ item.label }}
              </div>
            </div>
            <el-button
              v-if="curTab == 2"
              @click="downloadImg"
              icon="el-icon-download"
              class="other"
              >导出为图片</el-button
            >
          </div>
          <div class="map-content">
            <MapCom
              ref="MapCom"
              :pointInfo="pointInfo"
              v-if="curTab == 1"
            ></MapCom>
            <point
              ref="point"
              :pointInfo="pointInfo"
              :pointType="pointType"
              v-if="curTab == 2"
            ></point>
          </div>
        </div>
      </div>
    </div>
    <div class="route-box">
      <div
        class="route-item"
        v-for="(item, index) in routeList"
        :key="index"
        @click="goToOther(item.route)"
      >
        <img :src="require(`@/assets/image/r${index + 1}.png`)" alt="" />
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :pointInfo="pointInfo"
      @refreshList="refreshList"
    >
    </addDialog>
  </div>
</template>
<script>
import MapCom from "./components/map.vue";
import point from "./components/point.vue";
import addDialog from "./components/addDialog.vue";
import {
  getPointLevelListTree,
  getPointLevelById,
  getPointTypeListPage,
  delPointLevelById
} from "@/api/point.js";
export default {
  components: { MapCom, point, addDialog },
  data() {
    return {
      defaultProps: {
        children: "childs",
        label: "pointName"
      },

      treeData: [],
      curTab: "1",
      tabsOptions: [
        {
          label: "点位地图",
          value: "1"
        },
        {
          label: "点位码",
          value: "2"
        }
      ],
      routeList: [
        {
          text: "点位事项",
          route: "/pointEvent"
        },
        {
          text: "点位人员",
          route: "/pointPerson"
        }
      ],
      curItem: {},
      pointInfo: {},
      curId: "",
      isAdd: false,
      pointType: [],
      levelCode: "",
      filterText: "",
      dialogVisible: false
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
    this.getPointLevelListTreeFun();
  },
  methods: {
    downloadImg() {
      this.$refs.point.downloadImg();
    },
    goToOther(route) {
      if (!route) return;
      this.$router.push({
        path: route
      });
    },
    refreshList() {
      this.$refs.MapCom.getPointGeoJsonFun();
    },
    openDialog(item, flag) {
      this.isAdd = flag;
      this.curItem = item;
    },
    handleNodeClick(item) {
      this.levelCode = item.levelCode;
      this.curId = item.id;
      this.getPointLevelByIdFun();
    },
    tabsChange(item) {
      this.curTab = item.value;
    },
    async getPointLevelListTreeFun() {
      const res = await getPointLevelListTree({
        id: "0"
      });
      this.treeData = res.data.data;
      if (this.treeData.length && !this.curId) {
        this.curId = this.treeData[0].id;
      }
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.curId);
      });
      this.getPointLevelByIdFun();
    },
    async getPointLevelByIdFun() {
      if (!this.curId) return;
      const res = await getPointLevelById({
        id: this.curId
      });
      this.pointInfo = res.data.data;
      if (this.pointInfo.consultationHotline)
        this.pointInfo.phoneList = JSON.parse(
          this.pointInfo.consultationHotline
        )
          .map(item => item.phone)
          .join("、");
    },
    async getPointTypeListPageFun() {
      const res = await getPointTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.pointType = res.data.data.records;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.pointName.indexOf(value) !== -1;
    }
  },
  computed: {
    getTypeName() {
      let name = "";
      if (this.pointType.length) {
        this.pointType.forEach(item => {
          if (item.id == this.pointInfo.pointTypes) {
            name = item.typeName;
          }
        });
      }
      return name;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  padding-bottom: 24px;
  height: auto;

  .section {
    display: flex;
    padding: 0;

    .left {
      width: 23%;
      max-height: 1000px;
      padding: 30px 24px;
      overflow: auto;
    }

    .right {
      width: 77%;
      height: 100%;

      .right-top {
        height: 190px;
        width: 100%;
        margin-bottom: 24px;
        background: url("~@/assets/image/top-base.png") no-repeat center;
        background-size: 100% 100%;
        padding: 29px 23px 17px 26px;

        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: MiSans, MiSans;
          font-weight: 700;
          font-size: 24px;
          color: #494c4f;

          .type {
            margin-left: 8px;
            padding: 3px 8px;
            background: rgba(0, 144, 255, 0.1);
            border-radius: 4px;
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #0090ff;
          }
        }

        .user-info {
          margin-top: 8px;

          .area {
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #0090ff;
          }

          .info-item {
            display: flex;
            align-items: center;

            margin-right: 48px;

            .label {
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 16px;
              color: #92979c;
              margin-right: 12px;
            }

            .value {
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 16px;
              color: #494c4f;
            }
          }
        }
      }
      .right-top1 {
        width: 100%;
        // height: 190px;
        background: #fff url("~@/assets/image/top-base.png") center no-repeat;
        background-size: 100% 100%;
        margin-bottom: 8px;
        padding: 28px 48px;

        .street {
          font-family: MiSans, MiSans;
          font-weight: 700;
          font-size: 24px;
          color: #494c4f;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .content {
          margin-top: 8px;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 18px;
          color: #494c4f;
        }
        .info-box {
          margin-top: 12px;
          display: flex;
          align-items: center;

          .info-box-item {
            display: flex;
            align-items: center;
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #494c4f;
            margin-right: 54px;

            img,
            span {
              margin-right: 8px;
            }

            img {
              height: 15px;
            }
          }

          .info-box-item:last-child {
            margin-right: 0;
          }
        }
      }
      .right-bottom {
        height: calc(100% - 214px);
        width: 100%;
        // max-height: 719px;
        // min-height: 561px;

        .tabs {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 38px;
          padding-right: 24px;
          margin-bottom: 8px;

          .tabs-box {
            display: flex;
            align-items: center;

            .tabs-item {
              padding-top: 10px;
              padding-bottom: 8px;
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 20px;
              color: #92979c;
              margin-right: 48px;
              cursor: pointer;
              position: relative;
            }

            .tabs-item.active {
              font-family: MiSans, MiSans;
              font-weight: 700;
              font-size: 20px;
              color: #494c4f;
            }

            .tabs-item.active::after {
              content: "";
              position: absolute;
              left: 0;
              bottom: 0;
              height: 4px;
              width: 100%;
              background: #0090ff;
              border-radius: 2px;
            }
          }

          .tupian-box {
            display: flex;
            align-items: center;

            width: 68px;

            .tupian-item {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              padding: 8px;
              height: 38px;
            }

            .tupian-item:first-child {
              border-radius: 4px 0px 0px 4px;
              border: 1px solid #e0e0e0;

              img {
                height: 16px;
              }
            }

            .tupian-item:last-child {
              border-radius: 0px 4px 4px 0px;
              border: 1px solid #e0e0e0;

              img {
                height: 20px;
              }
            }
          }
        }

        .map-content {
          width: 100%;
          height: calc(100% - 56px);
          // min-height: 505px;
        }
      }
    }
  }
}

.route-box {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  padding: 12px 8px;
  background: #fff;
  border-radius: 8px 0px 0px 8px;

  .route-item {
    padding: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 13px;
    color: #92979c;
    border-bottom: 1px solid #e0e0e0;
    cursor: pointer;

    img {
      height: 32px;
    }

    .text {
      margin-top: 8px;
    }
  }

  .route-item:last-child {
    border: none;
  }
}

/deep/.el-tree-node__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #32325a;
}

/deep/.el-tree-node.is-current {
  background: rgba(247, 250, 255, 1);

  .el-tree-node__label {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 700;
    color: #036eff;
  }
}

/deep/.el-tree-node__content:hover,
/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: rgba(247, 250, 255, 1);
}

/deep/.el-tree-node__content {
  height: 38px;
}

.custom-tree-node {
  width: 100%;
  padding-right: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/motherChildPoint/index.vue